import { render, staticRenderFns } from "./TrainRefund.vue?vue&type=template&id=6c8e71d1&scoped=true&"
import script from "./TrainRefund.vue?vue&type=script&lang=js&"
export * from "./TrainRefund.vue?vue&type=script&lang=js&"
import style0 from "./TrainRefund.vue?vue&type=style&index=0&id=6c8e71d1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8e71d1",
  null
  
)

export default component.exports